import React from "react";
import { useTranslation } from "react-i18next";

import { Box, Stack } from "@mui/material";
import { FormikProps } from "formik";

import { FormValues } from "../../schemas";
import { FacilityWizardFeesSection } from "../FacilityWizardFeesSection";
import { OptionCard } from "../OptionCard";
import { QuestionSlot } from "../QuestionSlot";

interface Step6Props {
  formik: FormikProps<FormValues>;
  hasFees: boolean | null;
  setHasFees: (v: boolean) => void;
}

export const Step6Fees: React.FC<Step6Props> = ({ formik, hasFees, setHasFees }) => {
  const { t } = useTranslation("debt");
  const { setFieldValue } = formik;

  return (
    <Box>
      <QuestionSlot visible label={t("wizard.fees.question")}>
        <Stack spacing={2}>
          <OptionCard
            value="no"
            selected={hasFees === false}
            onSelect={() => {
              setHasFees(false);
              setFieldValue("fees", []);
            }}
            title={t("wizard.fees.noFees")}
            subtitle={t("wizard.fees.noFeesDesc")}
          />
          <OptionCard
            value="yes"
            selected={hasFees === true}
            onSelect={() => setHasFees(true)}
            title={t("wizard.fees.yesFees")}
            subtitle={t("wizard.fees.yesFeesDesc")}
          />
        </Stack>
      </QuestionSlot>

      <QuestionSlot visible={hasFees === true} label={t("wizard.fees.defineQuestion")}>
        <FacilityWizardFeesSection formik={formik} />
      </QuestionSlot>
    </Box>
  );
};
